// 电子合同菜单
import LayoutSidebar from '@/layout/layout-sidebar/layout-sidebar'
import { hetongguanli, hetongmoban } from '@/utils/images'

// 动态路由，基于用户权限动态去加载
const dynamicRoutes = [
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '10000',
    meta: {
      idthat: '10000',
    },
    redirect: '/eleContract/contract/contractManage',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: hetongguanli,
    children: [
      {
        path: '/eleContract/contract/contractManage',
        component: () =>
          import('@/views/eleContract/contract/contractManage/index'),
        menuShow: true,
        name: '合同管理',
        meta: {
          idthat: '10000',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true,
    menuShow: false,
    children: [
      {
        path: '/eleContract/contract/addContract',
        component: () =>
          import('@/views/eleContract/contract/contractDetail/index'),
        name: '发起合同',
        meta: {
          idthat: '10001',
          activeMenu: '/eleContract/contract/contractManage',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true,
    menuShow: false,
    children: [
      {
        path: '/eleContract/contract/contractDetail',
        component: () =>
          import('@/views/eleContract/contract/contractDetail/index'),
        name: '合同详情',
        meta: {
          idthat: '10002',
          activeMenu: '/eleContract/contract/contractManage',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '10003',
    meta: {
      idthat: '10003',
    },
    redirect: '/eleContract/contract/contractTemplate',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon',
    iconUrl: hetongmoban,
    children: [
      {
        path: '/eleContract/contract/contractTemplate',
        component: () =>
          import('@/views/eleContract/contract/contractTemplate/index'),
        menuShow: true,
        name: '合同模板',
        meta: {
          idthat: '10003',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true,
    menuShow: false,
    children: [
      {
        path: '/eleContract/contract/addContractTemplate',
        component: () =>
          import('@/views/eleContract/contract/contractTemplateAdd/index'),
        name: '新增模板',
        meta: {
          idthat: '10004',
          activeMenu: '/eleContract/contract/contractTemplate',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true,
    menuShow: false,
    children: [
      {
        path: '/eleContract/contract/contractTemplateDetail',
        component: () =>
          import('@/views/eleContract/contract/contractTemplateAdd/index'),
        name: '模板详情',
        meta: {
          idthat: '10005',
          activeMenu: '/eleContract/contract/contractTemplate',
        },
      },
    ],
  },
]
export default dynamicRoutes
